import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { files } from "../configs";
import { Context } from "../GlobalContext";
import CheckIcon from "../atoms/CheckIcon";
import Swal from "sweetalert2";
import "../global/pages.css";
import "./Confirm.css";
import Axios from "axios";

const Confirm = ({ history }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [checkAgree, setCheckAgree] = useState(null);

  const [checkAgreeChildParent, setCheckAgreeChildParent] = useState(null);
  const [checkAgreeChildUnder14, setCheckAgreeChildUnder14] = useState(null);

  const { token, userData, reqInfoPages, firstSurvType } = useContext(Context);
  const fieldsList = userData.requiredInfo;

  const submit = () => {
    const nextPage = reqInfoPages.needsInfoOne
      ? `/token/${token}/info-1`
      : reqInfoPages.needsInfoTwo
      ? `/token/${token}/info-2`
      : `/token/${token}/intro/${firstSurvType}/0/0/0`;

    // 조건 1: checkAgree는 무조건 있어야 함
    if (checkAgree !== "true") {
      Swal.fire({
        title: "확인해 주세요!",
        confirmButtonText: "닫기",
        confirmButtonColor: "#00aeef",
        text: "본인에게 해당하는 모든 동의서에 동의해주세요.",
        heightAuto: false,
      });
      return;
    }

    if (!(userData.subjectType.id === 1 || userData.subjectType.id === 2)) {
      history.push(nextPage);
    }

    // 조건 3: checkAgreeChildUnder14가 true일 경우 checkAgreeChildParent는 무조건 true여야 함
    if (checkAgreeChildUnder14 === "true") {
      if (checkAgreeChildParent !== "true") {
        Swal.fire({
          title: "확인해 주세요!",
          confirmButtonText: "닫기",
          confirmButtonColor: "#00aeef",
          text: "보호자 동의서에 동의하여야 설문 진행이 가능합니다.",
          heightAuto: false,
        });
        return;
      }

      // phone, name 체크
      if (
        phone === "" ||
        !/^\d{2,3}\d{3,4}\d{4}$/g.test(phone.replaceAll(/-/g, ""))
      ) {
        Swal.fire({
          title: "확인해 주세요!",
          confirmButtonText: "닫기",
          confirmButtonColor: "#00aeef",
          text: "법적 대리인의 휴대전호를 올바르게 입력해 주세요!",
          heightAuto: false,
        });
        return;
      }

      if (name === "") {
        Swal.fire({
          title: "확인해 주세요!",
          confirmButtonText: "닫기",
          confirmButtonColor: "#00aeef",
          text: "법적 대리인의 이름을 입력해 주세요!",
          heightAuto: false,
        });
        return;
      }

      Axios.post(
        "https://v2-survey-api.withchildren.org/children-parent-info",
        {
          token,
          phone: phone.replaceAll(/-/g, ""),
          name,
        }
      )
        .then((data) => {
          localStorage.setItem(
            "children_parent_info",
            phone.replaceAll(/-/g, "")
          );
          localStorage.setItem("children_parent_info_name", name);
          history.push(nextPage);
        })
        .catch(() => {
          Swal.fire({
            title: "오류가 발생했습니다!!",
            confirmButtonText: "닫기",
            confirmButtonColor: "#00aeef",
            text: "다시 시도해 주세요!",
            heightAuto: false,
          });
        });
    } else {
      // checkAgreeChildUnder14가 true가 아닌 경우 바로 다음 페이지로
      history.push(nextPage);
    }
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("agree"));

    if (saved) {
      setCheckAgree(saved.checkAgree);

      setCheckAgreeChildParent(saved.checkAgreeChildParent);
    }

    const info = localStorage.getItem("children_parent_info");
    if (info) {
      setPhone(info);
    }
    const infoname = localStorage.getItem("children_parent_info_name");
    if (infoname) {
      setName(infoname);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "agree",
      JSON.stringify({
        checkAgree,
        checkAgreeChildParent,
      })
    );
  }, [checkAgree, checkAgreeChildParent]);

  return (
    <div className="container" id="confirm__container">
      <div className="title" id="confirm__title">
        <div className="icon">
          <img src={files + "/warning.svg"} alt="개인정보 동의서 작성" />
        </div>
        <h3>개인정보 동의서 작성</h3>
      </div>
      <div className="content" id="confirm__content">
        {fieldsList.includes("agree") ? (
          <div className="content-inner" id="confirm__content-first">
            <div className="inner-title">
              <div className="check-icon">
                <CheckIcon color="#FFD012" />
              </div>
              <h5>{userData.gov.agreementTitle}</h5>
            </div>
            <div className="inner-figure">{userData.gov.agreementContent}</div>
            <div className="inner-check">
              <p>
                <input
                  type="radio"
                  name="agreement-first"
                  value="true"
                  onChange={(e) => setCheckAgree(e.target.value)}
                  checked={checkAgree === "true"}
                />
                <span>동의합니다</span>
                <input
                  type="radio"
                  name="agreement-first"
                  value="false"
                  onChange={(e) => setCheckAgree(e.target.value)}
                  checked={checkAgree === "false"}
                />
                <span>동의하지 않습니다</span>
              </p>
            </div>
            {(userData.subjectType.id === 1 ||
              userData.subjectType.id === 2) && (
              <div className="inner-check">
                <p>
                  <input
                    type="checkbox"
                    name="agreement-child-under-14"
                    value="true"
                    onChange={(e) => setCheckAgreeChildUnder14(e.target.checked ? "true" : "false")}
                    checked={checkAgreeChildUnder14 === "true"}
                  />
                  <span>만14세 미만이면 체크하세요.</span>
                </p>
              </div>
            )}
          </div>
        ) : null}
        {checkAgreeChildUnder14 === "true" &&
        fieldsList.includes("agreeAsParent") &&
        (userData.subjectType.id === 1 || userData.subjectType.id === 2) ? (
          <div className="content-inner" id="confirm__content-second">
            <div className="inner-title">
              <div className="check-icon">
                <CheckIcon color="#FFD012" />
              </div>
              <h5>정보주체가 만 14세 미만의 아동인 경우 체크</h5>
            </div>
            <div className="inner-figure">
              <p>
                정보주체가 만14세 미만의 아동인 경우 위와 같이 개인정보를
                제공하는데 동의합니다.
              </p>
              <p>
                ※ 만 14세 미만의 경우 자신의 정보 제공을 함에 있어 법정 대리인의
                동의가 필요함.
              </p>
            </div>
            <div className="inner-check">
              {/* <div className="check-second">
                <p className="check-obj">본인</p>
                <p className="check-box">
                  <input
                    type="radio"
                    name="agreement-second"
                    value="true"
                    onChange={(e) => setCheckAgreeChild(e.target.value)}
                    checked={checkAgreeChild === "true"}
                  />
                  <span>동의합니다</span>
                  <input
                    type="radio"
                    name="agreement-second"
                    value="false"
                    onChange={(e) => setCheckAgreeChild(e.target.value)}
                    checked={checkAgreeChild === "false"}
                  />
                  <span>동의하지 않습니다</span>
                </p>
              </div>
              <hr /> */}
              <div className="check-second">
                <p className="check-obj">법적 대리인</p>
                <p className="check-box">
                  <input
                    type="radio"
                    name="agreement-second-parent"
                    value="true"
                    onChange={(e) => setCheckAgreeChildParent(e.target.value)}
                    checked={checkAgreeChildParent === "true"}
                  />
                  <span>동의합니다</span>
                  <input
                    type="radio"
                    name="agreement-second-parent"
                    value="false"
                    onChange={(e) => setCheckAgreeChildParent(e.target.value)}
                    checked={checkAgreeChildParent === "false"}
                  />
                  <span>동의하지 않습니다</span>
                </p>
              </div>
              <hr />
              <div className="check-second">
                <p className="check-obj">법적 대리인의 이름</p>
                <p className="check-box">
                  <input
                    type="text"
                    name="agreement-second-parent"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    style={{
                      width: "100%",
                      padding: 12,
                      textAlign: "right",
                    }}
                  />
                </p>
              </div>
              <hr />
              <div className="check-second">
                <p className="check-obj">법적 대리인의 휴대전화번호</p>
                <p className="check-box">
                  <input
                    type="text"
                    name="agreement-second-parent"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    style={{
                      width: "100%",
                      padding: 12,
                      textAlign: "right",
                    }}
                  />
                </p>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <div className="link-buttons">
        <Link
          to={
            reqInfoPages.needsInfoTwo
              ? `/token/${token}/info-2`
              : reqInfoPages.needsInfoOne
              ? `/token/${token}/info-1`
              : `/token/${token}/greeting`
          }
          className="link-btn"
          alt="뒤로 버튼"
          style={{
            display: "none",
          }}
        >
          뒤로
        </Link>
        <button className="link-btn" onClick={submit} alt="다음으로 버튼">
          다음으로
        </button>
      </div>
    </div>
  );
};

export default Confirm;
